import { render } from "./AboutPage.vue?vue&type=template&id=5a0f3b86&scoped=true&ts=true"
import script from "./AboutPage.vue?vue&type=script&lang=ts"
export * from "./AboutPage.vue?vue&type=script&lang=ts"

import "./AboutPage.vue?vue&type=style&index=0&id=5a0f3b86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0f3b86"]])

export default __exports__